import { render, staticRenderFns } from "./accountSafe.vue?vue&type=template&id=70eb4a43&scoped=true"
import script from "./accountSafe.vue?vue&type=script&lang=js"
export * from "./accountSafe.vue?vue&type=script&lang=js"
import style0 from "../asset/css/accountSafe.scss?vue&type=style&index=0&id=70eb4a43&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eb4a43",
  null
  
)

export default component.exports